import { competitorRows } from '@/lib/competitors'
import type { CompetitorGridProps } from './CompetitorGrid.types'

export function CompetitorGrid({
  competitors,
  scores,
  trackedBrand,
}: CompetitorGridProps) {
  const rows = competitorRows(competitors, scores, trackedBrand)

  return (
    <div className="p-6 rounded-xl border border-border bg-card">
      <h3 className="text-sm font-semibold mb-1">Detected Competitors</h3>
      <p className="text-xs text-muted-foreground mb-4">
        Brands the AI mentioned in your category — auto-detected (top 30)
      </p>
      {rows.length === 0 ? (
        <div className="text-sm text-muted-foreground py-4">
          No other brands detected.
        </div>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-2">
          {rows.map((row) => (
            <div
              key={row.name}
              className="flex items-center justify-between px-3 py-2 rounded-md bg-secondary/40 border border-border"
            >
              <span
                className={`text-sm truncate ${row.isTrackedBrand ? 'font-semibold' : 'font-medium'}`}
              >
                {row.name}
              </span>
              <span className="text-xs text-muted-foreground tabular-nums">
                {row.count}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
